module.exports = __webpack_public_path__ + "img/close_x_gray.abb4a5f7.svg";